import React, { useContext, ReactNode } from 'react';

export const PrincipalRefreshContext = React.createContext(() => { });

export const usePrincipalRefreshContext = () => useContext(PrincipalRefreshContext);

interface PrincipalRefreshProviderProps {
    children: ReactNode[] | ReactNode;
    refreshPrincipal: () => void;
}

export const PrincipalRefreshProvider = ({ children, refreshPrincipal }: PrincipalRefreshProviderProps) => {
    //console.debug(`PrincipalProvider: calling useGetPrincipal...`);
    return <PrincipalRefreshContext.Provider value={refreshPrincipal}>
        {children}
    </PrincipalRefreshContext.Provider>;
}
